// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import ReactLottie from "react-lottie";
import StarSuccessJson from "../assets/images/starSuccess.json";

var animation = StarSuccessJson;

function getAnimationOptions(param) {
  return {
          loop: false,
          autoplay: true,
          animationData: animation
        };
}

function takeMeBack(param) {
  window.history.back();
  
}

function RnRMilestoneAnimationComponent(Props) {
  var showConfetti = Props.showConfetti;
  if (showConfetti) {
    return React.createElement("div", {
                className: "milestoneAnimation__container"
              }, React.createElement(ReactLottie, {
                    options: {
                      loop: false,
                      autoplay: true,
                      animationData: animation
                    },
                    eventListeners: ([{
              "eventName": "complete",
              "callback": () => {
                if (!Props._showRewardModal) {
                  Props._refreshView();
                  takeMeBack();
                }
              }
            }]),
                    isClickToPauseDisabled: true
                  }));
  } else {
    return React.createElement("div", undefined);
  }
}

var make = RnRMilestoneAnimationComponent;

export {
  animation ,
  getAnimationOptions ,
  takeMeBack ,
  make ,
  
}
/* animation Not a pure module */
